import {
  CREATE_NEW_PASS,
  FORGOT_PASS,
  LOGIN, OTP_VERIF, REGISTRATION, RESEND_OTP, SIGNUP_VERIF,
} from '../actionTypes';

const initialState = {
  regisSuccess: false,
  loginSuccess: false,
  otpVerified: false,
  resendOtpSuccess: false,
  resetLinkSent: false,
  newPasswordSuccess: false,
  isLoading: false,
  error: false,
  message: '',
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${REGISTRATION}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        regisSuccess: false,
      };
    case `${REGISTRATION}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        regisSuccess: false,
      };
    case `${REGISTRATION}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        regisSuccess: true,
      };
    case `${LOGIN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        loginSuccess: false,
      };
    case `${LOGIN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        loginSuccess: false,
      };
    case `${LOGIN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        loginSuccess: true,
      };
    case `${RESEND_OTP}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        resendOtpSuccess: false,
      };
    case `${RESEND_OTP}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        resendOtpSuccess: false,
      };
    case `${RESEND_OTP}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        resendOtpSuccess: true,
      };
    case `${SIGNUP_VERIF}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${SIGNUP_VERIF}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${SIGNUP_VERIF}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
      };
    case `${OTP_VERIF}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        otpVerified: false,
      };
    case `${OTP_VERIF}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        otpVerified: false,
      };
    case `${OTP_VERIF}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        otpVerified: true,
      };
    case `${FORGOT_PASS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        resetLinkSent: false,
      };
    case `${FORGOT_PASS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        resetLinkSent: false,
      };
    case `${FORGOT_PASS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        resetLinkSent: true,
      };
    case `${CREATE_NEW_PASS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newPasswordSuccess: false,
      };
    case `${CREATE_NEW_PASS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        newPasswordSuccess: false,
      };
    case `${CREATE_NEW_PASS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newPasswordSuccess: true,
      };
    default:
      return state;
  }
}
